export const ASYNC_CREATE_FUND = 'ASYNC_CREATE_FUND';
export const ASYNC_EDIT_FUND = 'ASYNC_EDIT_FUND';
export const ASYNC_DELETE_FUND = 'ASYNC_DELETE_FUND';
export const ASYNC_RESTORE_FUND = 'ASYNC_RESTORE_FUND';
